import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ringBeam",
  "use": "icon-ringBeam-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ringBeam\"><path d=\"M711.2 862H318.4c-85 0-154.1-69.1-154.1-154.1V315.1c0-85 69.1-154.1 154.1-154.1h392.8c85 0 154.1 69.1 154.1 154.1v392.8c0 85-69.1 154.1-154.1 154.1zM318.4 251.6c-35 0-63.5 28.5-63.5 63.5v392.8c0 35 28.5 63.5 63.5 63.5h392.8c35 0 63.5-28.5 63.5-63.5V315.1c0-35-28.5-63.5-63.5-63.5H318.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol